import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Referral } from '@shared/models/referral';
import { ApiService } from '@shared/services';

@Injectable()
export class ReferralService extends ApiService<Referral> {
  constructor(http: HttpClient) {
    super(http);
    this.url = 'referrals/';
  }
}
